<template lang="pug">
  .card
    .card-content
      p.title.is-size-6
        b PG:&nbsp
        span.has-text-link {{ autotanque.pg }}
        br
      p.subtitle.is-size-7
        b Capacidad:&nbsp
        span.has-text-link {{ autotanque.capacidad }} Ltrs.
        br
        b Masa aproximada:&nbsp
        span.has-text-link {{ tons }} Ton.
        br
        b Porteador:&nbsp
        span.has-text-link {{ autotanque.porteador }}
        br
        b Comercializadora:&nbsp
        span.has-text-link {{ autotanque.comercializadora }}
        br
        b Grupo:&nbsp
        span.has-text-link {{ autotanque.grupo }}
        br
        b idCRE:&nbsp
        span.has-text-link {{ autotanque.idCRE }}
        br
        b Placa:&nbsp
        span.has-text-link {{ autotanque.placa }}
        br
</template>

<script>
  export default {
    name: 'CardAutotanque',
    props: {
      autotanque: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        tons: 0
      }
    },
    methods: {
      iniciarComponente () {
        this.calcularData()
      },
      calcularData () {
        let cap82 = 0
        let barriles = 0
        cap82 = Math.round(((parseInt(this.autotanque.capacidad) * 82)/90),2)
        barriles = cap82 / 158.9873
        this.tons = Math.round((barriles / 11.83) * 100) / 100
        console.log(`Cap82: ${cap82}`)
        console.log(`Barriles: ${barriles}`)
        console.log(`Tons: ${this.tons}`)
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
   
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/CardAutotanque.vue